export default async (ms: number) => new Promise((resolve) => {
  setTimeout(resolve, ms);
});
